import { useLang } from 'hooks/lang';
import { FormEvent, useState, useRef } from 'react';

import { IconInput } from 'components/Inputs';
import { UserIcon } from 'components/Icons';

import { FormWrapper } from './FormWrapper';

import { useAuth } from 'providers/Auth';

import { REGEX } from 'utils/constants';

export function SignInForm() {
  const emailRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);

  const { requestSignIn } = useAuth();

  const { t } = useLang();

  const handleLogIn = async (formEvent: FormEvent): Promise<void> => {
    formEvent.preventDefault();

    const email = emailRef.current?.value ?? '';

    const invalidState = [!email, loading, !REGEX.EMAIL.test(email)].some(Boolean);

    if (invalidState) return;

    setLoading(true);

    const success = await requestSignIn(email.toLowerCase());

    if (!success) setLoading(false);
  };

  return (
    <FormWrapper loading={loading} onSubmit={handleLogIn} buttonText={t('login')}>
      <IconInput
        icon={<UserIcon />}
        ref={emailRef}
        className="pl-10"
        name="email"
        placeholder={'Email'}
        required
        size="large"
      />
    </FormWrapper>
  );
}
